// Core
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Components
import { CustomersPageComponent } from "./containers/page/customers-page.component";

export const routes: Routes = [
  {
    path: "",
    component: CustomersPageComponent,
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomersRoutingModule {}
